export default __webpack_public_path__ + "static/media/LogoCatalogBlack.f0a86a8a.png";